export default __webpack_public_path__ + "static/fundamental1-4ec9f45dff638d83fc252b97363b7796.png";